import comp from "./AttendanceSync";
export default comp;
